import React from "react";
// import Image from "../../Assets/Common/loadingProgress.json";
import Image2 from "../../Assets/Common/98119-error.json";
import smallImage from "../../Assets/Common/smallLoadingProgress.json";
import { useLottie } from "lottie-react";
import { Box, Typography } from "@mui/material";
// import Logo from "../../Assets/Login/smallLogo.png";
import LoadingAnimation from "../../Assets/Common/LoadingAnimationNew.json";

export function LoadingProgressIcon() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoadingAnimation,
    style: {
      height: 150,
      width: 150,
    },
  };
  const { View } = useLottie(defaultOptions);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <Grid
        component="img"
        src={Logo}
        sx={{
          width: "3vw",
          height: "3vw",
          mb: "10px",
        }}
      /> */}
      {View}
      <Typography
        variant="body2"
        sx={(t) => ({
          borderRadius: "12px",
          fontWeight: 600,
          display: { xs: "none", sm: "block", md: "block" },
        })}
      >
        Please wait, we are processing your request...
      </Typography>
      <Typography
        variant="body2"
        sx={(t) => ({
          borderRadius: "12px",
          fontWeight: 600,
          display: {
            xs: "block",
            sm: "none",
            md: "none",
          },
        })}
      >
        Please wait, Loading...
      </Typography>
    </Box>
  );
}

export function SystemErrorIcon({ error }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Image2,
    style: {
      width: "100%",
    },
  };

  const { View } = useLottie(defaultOptions);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "250px" }}>{View}</Box>

      <Typography
        variant="body2"
        sx={(t) => ({
          borderRadius: "12px",
          fontWeight: 600,
        })}
      >
        Something Went Wrong ! Please Try Again Later.
      </Typography>
      {error && (
        <Typography
          variant="body2"
          sx={(t) => ({
            borderRadius: "12px",
            fontWeight: 600,
          })}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
}

export function SmallLoadingProgressIcon() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: smallImage,
    style: {
      width: "100%",
    },
  };

  const { View } = useLottie(defaultOptions);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "80px" }}>{View}</Box>
    </Box>
  );
}
